import type { UIMessage } from 'ai'

export function selectRequestMessages<T extends UIMessage>(messages: T[], sendOnlyLastMessage: boolean): T[] {
  // Assistant continuations need the user request, even when server memory is missing.
  return sendOnlyLastMessage && messages.at(-1)?.role === 'user'
    ? messages.slice(-1)
    : messages
}
